import React from "react";
import { Table, Typography } from "antd";
import type { TableProps } from "antd";
import { wrappedText } from "../../../../components/Shared/utils";

interface DataType {
  key: string;
  name: string;
  email: string;
}
type ColumnsType<T extends object> = TableProps<T>["columns"];

interface ContactTableProps {
  id?: string | number;
  title: string;
  contacts?: DataType[];
  onDelete?: (key: string) => void;
  onEdit?: (key: string) => void;
  showActions?: boolean;
}

const ContactTable: React.FC<ContactTableProps> = (props) => {
  const { id, title, contacts, showActions } = props;

  const columns: ColumnsType<DataType> = [
    {
      title: "Name",
      dataIndex: title === "Requester" ? "requestername" : "suppliername",
      width: "20%",
      render: (text: any) => wrappedText(text, 30),
    },
    {
      title: "Title",
      dataIndex: title === "Requester" ? "requesterTitle" : "supplierTitle",
      width: "20%",
      render: (text: any) => wrappedText(text, 30),
    },
    {
      title: "Functional Area",
      dataIndex: title === "Requester" ? "requesterArea" : "supplierArea",
      width: "25%",
      render: (text: any) => wrappedText(text, 30),
    },
    {
      title: "Company",
      dataIndex: title === "Requester" ? "requesterCompany" : "supplierCompany",
      width: "20%",
      render: (text: any) => wrappedText(text, 30),
    },
    {
      title: "Phone",
      dataIndex: title === "Requester" ? "requesterPhone" : "supplierPhone",
      width: "20%",
    },
    {
      title: "Email",
      dataIndex: title === "Requester" ? "requesteremail" : "supplieremail",
      width: "20%",
      render: (text: any) => wrappedText(text, 30),
    },
    ...(showActions
      ? [
        {
          title: "Action",
          key: "action",
          width: "20%",
          render: (_: any, record: DataType) => {
            return (
              <>
                <span>
                  <Typography.Link
                    style={{ marginInlineEnd: 8 }}
                    onClick={() => props.onEdit?.(record.key)}
                  >
                    Edit
                  </Typography.Link>
                  <Typography.Link
                    style={{ marginInlineEnd: 8 }}
                    onClick={() => props.onDelete?.(record.key)}
                  >
                    Remove
                  </Typography.Link>
                </span>
              </>
            );
          },
        },
      ]
    : []),
  ];

  return (
    <div id={`contact-table-${id}`}>
      <span className="table-title" style={{ fontSize: '16px', fontWeight: 400 }}>{title}</span>

      <Table<DataType>
        columns={columns}
        dataSource={contacts}
        pagination={false}
        size="small"
        tableLayout="fixed"
        rowKey="key" // Ensure each row has a unique key
        locale={{ emptyText: null }} // Suppress the "No data" message
      />
    </div>
  );
};

export default ContactTable;
